'use client';

import { ThemeProvider } from '@/contexts/ThemeContext';

export function ThemeWrapper({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <div style={{ 
        backgroundColor: 'var(--background-primary)',
        color: 'var(--text-primary)',
        minHeight: '100vh'
      }}>
        {children}
      </div>
    </ThemeProvider>
  );
}
